export const AdminLoginTypes = {
    LOGIN_ADMIN:'LOGIN_ADMIN'
}